// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuestionHeader_wrapper__mLnlq","title":"QuestionHeader_title__4ol4_"};